export default class CategoriaProduto {
	constructor(
		nome=''
	){
		this.nome = nome;
	}
}